import { styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { Ancestor } from '#enums/ancestors.ts';
import { ContentWithLineBreaks } from '../ContentWithLineBreaks/index.tsx';
import { SlideoutDrawer } from '../SlideoutDrawer/index.tsx';
import { type Props } from './types.ts';

const OverviewContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}));

export const OverviewDrawer = ({ content, name, setActiveOverviewDrawer, titleSuffix = 'overview' }: Props) => {
  const [open, setOpen] = useState<boolean>(true);

  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setActiveOverviewDrawer(undefined);
      }, 310);
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <SlideoutDrawer ancestor={Ancestor.Overview} open={open} setOpen={setOpen} title={`${name} ${titleSuffix}`}>
      <OverviewContainer>
        <ContentWithLineBreaks sx={{ color: theme => theme.mainTextPrimary }}>{content}</ContentWithLineBreaks>
      </OverviewContainer>
    </SlideoutDrawer>
  );
};
